import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Spin } from 'antd';
import Translate from 'react-translate-component';

import { generateImageUrl, generateMetroImageUrl } from 'constants/urls';

export default class DocumentImage extends Component {
    static propTypes = {
        document: PropTypes.object.isRequired
    };

    state = {
        error: false,
        loaded: false
    }

    showError = () => {
        this.setState({ error: true });
    }

    removePreloader = () => {
        this.setState({ loaded: true });
    }

    renderError() {
        return (
            <Alert message={<Translate content="errors.loadImageError" />} type="error" className="text-center m-l-15 m-r-15" />
        );
    }

    renderImage() {
        const isMetroDocument = this.props.document.metro;
        const name = this.props.document.text;
        const url = isMetroDocument ? generateMetroImageUrl(this.props.document) : generateImageUrl(this.props.document);

        return (
            <img
                className="image-preview"
                onLoad={this.removePreloader}
                onError={this.showError}
                src={url}
                alt={name}
            />
        );
    }

    render() {
        const { error, loaded } = this.state;

        return (
            <div className="preview-paddings">
                <Spin spinning={!loaded && !error} wrapperClassName="document-image-spin">
                    { error ? this.renderError() : this.renderImage() }
                </Spin>
            </div>
        );
    }
}
